import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { BsShop } from "react-icons/bs";
import { FaSearch,FaCalculator } from 'react-icons/fa'; // Example for a search icon
import './traceShipping.css'
import { Col, Container, Row } from 'react-bootstrap';

const traceShipping = () => {
  // const [searchTerm, setSearchTerm] = useState('');

      const handleSearchChange = (event) => {
        // setSearchTerm(event.target.value);
      };

      const handleSearchSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        console.log('Searching for:');
        // Implement your search logic here
      };

  return (
   <div className="trace-shipping align-items-center justify-content-center">    
      <Container className='trace-container'>        
          <Row className="trace-shipping-row">
            <Col className="trace-shipping-content ">
                <Row className="trace-shipping-title align-items-center justify-content-center">
                  <Col sm className="trace-shipping-input p-2 ">
                    <Form onSubmit={handleSearchSubmit}>
                      <InputGroup>
                        <Form.Control className='text-white'
                          type="search"
                          placeholder="Search..."
                          aria-label="Search"
                          // value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <Button variant="outline-secondary" type="submit">
                          <FaSearch /> 
                        </Button>
                      </InputGroup>
                    </Form>
                  </Col>
                  <Col sm className="trace-shipping-center  p-2">
                  <span>TARIF PENGIRIMAN</span> <FaCalculator className='my-icon-container'/>
                  </Col>
                  <Col sm className="trace-shipping-agen p-2 ">
                  <span>AGEN KAMI</span> <BsShop className='my-icon-container'/>
                  </Col>
                </Row>
              </Col>
          </Row>
      </Container>
   </div>
  )
}

export default traceShipping